import { RequestStatus } from "@app/constants";
import { RootState } from "@app/redux/root-reducer";

export const selectBrandState = (store: RootState) => store.brandReducer.brand;
export const selectVehicleTypeState = (store: RootState) => {
  const findWheeler = store.brandReducer.findWheeler || {};
  return {
    wheelers: findWheeler.data || [],
    loading: findWheeler.status === RequestStatus.RUNNING,
    error: findWheeler.error,
    status: findWheeler.status,
  };
};

export const ProductIdDataState = (store: RootState) =>
  store.brandReducer.findIdByProduct;

export const modelByIdDataState = (store: RootState) =>
  store.brandReducer.findModelById;
